import styled from "styled-components";

import content from "../content/account-activation";
import activationDe from "../images/Activation_de.jpg";
import activationEn from "../images/Activation_en.jpg";
import activationEs from "../images/Activation_es.jpg";
import activationFr from "../images/Activation_fr.jpg";
import activationPl from "../images/Activation_pl.jpg";
import activationPt from "../images/Activation_pt.jpg";
import activationRu from "../images/Activation_ru.jpg";
import activationTr from "../images/Activation_tr.jpg";
import { colors, device, paddingSmall } from "../variables";

const images = {
  en: activationEn,
  ru: activationRu,
  es: activationEs,
  de: activationDe,
  fr: activationFr,
  pt: activationPt,
  tr: activationTr,
  pl: activationPl,
};

const AccountActivation = ({ language }) => {
  document.title = "Chess Universe | Account Activation";
  const imageSrc = images[language];

  return (
    <AccountActivationWrapper>
      <Wrapper>
        <ContentWrapper>
          <div>
            <Element>{content[0][language]}</Element>
            <Element>{content[1][language]}</Element>
          </div>
          <Image src={imageSrc} />
        </ContentWrapper>
      </Wrapper>
    </AccountActivationWrapper>
  );
};

const AccountActivationWrapper = styled.div`
  max-height: 1000px;
  height: calc(100vh - 200px);
  background-color: rgb(85, 85, 85);
`;

const Wrapper = styled.div`
  position: absolute;
  height: calc(100vh - 200px);
  top: 100px;
  left: 0;
  z-index: 3;
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ContentWrapper = styled.div`
  padding: 100px ${paddingSmall};
  text-align: center;
  width: 100%;
  @media ${device.laptop} {
    padding: 100px 0;
  }
`;

const Element = styled.div`
  font-family: NotoSansDisplay;

  &:first-child {
    margin-bottom: ${paddingSmall};
  }

  &:not(:first-child) {
    color: ${colors.yellow};
    text-transform: uppercase;
  }
`;

const Image = styled.img`
  margin-top: 40px;
  width: 100%;

  @media ${device.laptop} {
    max-width: 550px;
  }
`;

export default AccountActivation;
